import React from 'react'
import PropTypes from 'prop-types'
import Select from '../../../Select'

const propTypes = {
  form: PropTypes.object,
  field: PropTypes.object,
  isLoading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
}

const SearchableSelect = ({ form, field, options, isLoading }) => {
  const { setFieldValue } = form
  const { name, value, onBlur } = field
  return (
    <Select
      name={name}
      onBlur={onBlur}
      options={options}
      isLoading={isLoading}
      onChange={option => setFieldValue(name, option.value)}
      value={options ? options.find(option => option.value === value) : null}
    />
  )
}

SearchableSelect.propTypes = propTypes

export default SearchableSelect
